<template>
  <div class="top-catg">
    <div class="img-top">
      <img class="w-100" src="../../images/cyber-banner.webp" alt="" />
    </div>
    <div class="categories-img">
      <div class="text-catg">
        <h3 class="pt-15 text-cat">top categories</h3>
      </div>
      <v-container>
        <a
          href="#"
          class="text-black pt-5"
          style="font-size: 14px; text-align: end; display: block"
          >Shop All</a
        >
        <v-row style="margin-top: 40px">
          <v-col
            cols="6"
            md="3"
            sm="4"
            lg="2"
            v-for="top in dataTop"
            :key="top.title"
            class="mb-4"
          >
            <v-card class="text-center" elevation="0">
              <v-hover v-slot="{ isHovering, props }">
                <img
                  class="imge-cat"
                  :style="`transition: 0.2s all ease-in-out;cursor: pointer; scale:${
                    isHovering ? 1.06 : 1
                  } ;`"
                  :src="top.imge"
                  alt=""
                  v-bind="props"
                />
              </v-hover>
              <v-card-title style="font-size: 15px">
                {{ top.title }}
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<style scoped lang="css">
.top-catg .text-catg {
  font-weight: 800;
  background: linear-gradient(65deg, #1f0dff, #67d767, #ff0000);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 30px;
  justify-content: center;
}
@media (max-width: 480px) {
  .top-catg .text-cat {
    font-size: 20px;
  }
  .top-catg .imge-cat {
    width: 130px;
  }
}
</style>

<script setup>
import { ref } from "vue";
const dataTop = ref([
  {
    imge: "https://new-ella-demo.myshopify.com/cdn/shop/files/mobile-phones.png?v=10616357514144629263",
    title: " Mobile Phones",
  },
  {
    imge: "https://new-ella-demo.myshopify.com/cdn/shop/files/laptops-tablets.png?v=17546078654541140209",
    title: " Labtops",
  },
  {
    imge: "https://new-ella-demo.myshopify.com/cdn/shop/files/televisions.png?v=792225267698738137",
    title: "  TVS",
  },
  {
    imge: "https://new-ella-demo.myshopify.com/cdn/shop/files/pcs-accessories.png?v=7913320403362682840",
    title: "  PCs",
  },
  {
    imge: "https://new-ella-demo.myshopify.com/cdn/shop/files/audio-video.png?v=17118273463527967791",
    title: "  Audio & Video",
  },
  {
    imge: "https://new-ella-demo.myshopify.com/cdn/shop/files/gaming-accessories.png?v=5365032838061682635",
    title: "  Gaming",
  },
  {
    imge: "https://new-ella-demo.myshopify.com/cdn/shop/files/home-appliances.png?v=4122646624966862882",
    title: "  Home Appliances",
  },
  {
    imge: "https://new-ella-demo.myshopify.com/cdn/shop/files/kitchen-appliances.png?v=912885117927234410",

    title: "Kitchen",
  },
  {
    imge: "https://new-ella-demo.myshopify.com/cdn/shop/files/cameras.png?v=10468174360605840515",

    title: "Cameras",
  },
  {
    imge: "https://new-ella-demo.myshopify.com/cdn/shop/files/consumables.png?v=1604898607781595964",

    title: "Consumables",
  },
  {
    imge: "https://new-ella-demo.myshopify.com/cdn/shop/files/smart-homes.png?v=11511407578445752828",

    title: "Smart Homes",
  },
  {
    imge: " https://new-ella-demo.myshopify.com/cdn/shop/files/accessories.png?v=16090558546215869367",

    title: " Accessories",
  },
]);
</script>
